<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M12.17 15.71h4.19a3 3 0 00-.89-2.23 5.34 5.34 0 00-3.29-.89 5.32 5.32 0 00-3.37 1A3.19 3.19 0 008 16a3.5 3.5 0 001 2.59 5.12 5.12 0 003.18.82 5.12 5.12 0 003.17-.81 3.31 3.31 0 001-2.6h-4.2zM16.64 16v3.27h5.83A1.61 1.61 0 0024 17.65 1.67 1.67 0 0022.47 16zM23.9 14.22a1.49 1.49 0 00-1.48-1.49h-5.78v3h5.88a1.52 1.52 0 001.38-1.51z"/><path d="M27 25H5a2 2 0 01-2-2V9a2 2 0 012-2h22a2 2 0 012 2v14a2 2 0 01-2 2zM5 8a1 1 0 00-1 1v14a1 1 0 001 1h22a1 1 0 001-1V9a1 1 0 00-1-1z"/></svg>